import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


let agendaSlider = $('.agenda__slider');

if (agendaSlider.length > 0) {
  agendaSlider.each(function () {
    let agendaSliderSwiper = new Swiper(this, {
      modules: [Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid],
      slidesPerView: 1,
      loop: false,
      wrapperClass: 'swiper-agenda',
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-agenda',
        prevEl: '.swiper-button-prev-agenda',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 75,
        },
        667: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });

    $(this).mouseenter(function() {
      (this).swiper.autoplay.stop();
    });

    $(this).mouseleave(function() {
      (this).swiper.autoplay.start();
    });

    agendaSliderSwiper.init();
  });
}

